import React from 'react';

export const DurationHelpText = () => (
  <p>
    The value must be specified as a number, followed immediately by one of the following units:
    <br />
    ms - milliseconds
    <br />
    s - seconds
    <br />
    m - minutes
    <br />
    h - hours
    <br />
    d - days - assuming a day has always 24h
    <br />
    w - weeks - assuming a week has always 7d
    <br />
    y - years - assuming a year has always 365d
    <br />
    <br />
    Exp: 15m, 1h30m, 2d10h8m7s, 10s
  </p>
);

